import {PathNode} from "@game/coregame/interfaces/PathNode";
import {Building} from "@game/coregame/ecs/entities/Building";

export class PathHolder {
    private _cachedWays: Map<string, PathNode[]> = new Map();

    constructor() {}
    static MAX_SPAWN_LEN_ONE_DIRECTION = 30;

    addPath(building: Building, path: PathNode[]) {
        this._cachedWays.set(building.stateId, path);
    }
    get(building: Building): PathNode[] {
        return this._cachedWays.get(building.stateId)!;
    }
    getPath(id: string) {
        return this._cachedWays.get(id);
    }
    getPathWidth() {
        // TODO: implement
        return PathHolder.MAX_SPAWN_LEN_ONE_DIRECTION;
    }
    clearCache() {
        this._cachedWays.clear();
    }
}
